import { Empty } from "antd";
import { useEffect, useState } from "react";

function PDFPage8Table3(props: any) {

    const [shareholderData, setShareholderData] = useState(props?.data);
    const [totalShareholder, setTotalShareholder] = useState({no_of_apartments:'', no_of_carspaces:'', no_of_other_spaces:'', percentage_of_shares:'0 %'});

    useEffect(() => {
        let shareData = props?.data.map((val: any) => {
            return {...val , percentage_of_shares: removeComma(val.percentage_of_shares)
            }
        });

        const result = Object.values(
            shareData.reduce((acc:any, obj:any) => ({ ...acc, [obj.shareholder_name]: obj }), {})
        );

        let sortedShareData = result.sort((a:any,b:any) => b.percentage_of_shares - a.percentage_of_shares)
        .map((val:any) => {return {...val , percentage_of_shares: addComma(val.percentage_of_shares.toString())}});

        setShareholderData(sortedShareData)
    },[props?.data])

    useEffect(() => {
        if(shareholderData.length){
            let resultTotal = shareholderData.reduce((preVal: any, currentVal:any) => {
                return {
                    no_of_apartments: parseFloat(preVal.no_of_apartments) + parseFloat(currentVal.no_of_apartments),
                    no_of_carspaces: parseFloat(preVal.no_of_carspaces) + parseFloat(currentVal.no_of_carspaces),
                    no_of_other_spaces: parseFloat(preVal.no_of_other_spaces) + parseFloat(currentVal.no_of_other_spaces),
                    percentage_of_shares : (parseFloat(preVal.percentage_of_shares?.toString()?.replace(',','.')) + parseFloat(currentVal.percentage_of_shares?.toString()?.replace(',','.'))).toFixed(1).replace('.',','),
                }
            }) 
            resultTotal.percentage_of_shares = resultTotal.percentage_of_shares + " %"; 
            setTotalShareholder(resultTotal);
        }
        
    },[shareholderData])

    const removeComma = (data: any) => {
        let newData = parseFloat(data.replace(',','.').replace(' %',''));
        return newData;
    }
    const addComma = (data: any) => {
        let newData = data.replace('.',',');
        return newData+' %';
    }

    return (
        <>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-12">
                <thead className="cu-bg-green ">
                    <tr className="align-top">
                        <th className="fw-600" style={{ width: "20%" }}>{props.TranslateString(`Henkilöriskit / Shareholderrisks (people) ** (both >=10% ownershipsand multiple apartments)`)}</th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("num_of_apartments_pdf")}</th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("Autopaikat lkm")}</th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("number_of_other_spaces")}</th>
                        <th className="cu-width-30p text-right fw-600">{props.TranslateString("the_percentage_of_the_shares_owned_of_hc")}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    {shareholderData.length > 0 ? shareholderData?.map((val: any) => {
                        return (<tr className='text-left' key={Math.random()}>
                            <td >{val?.shareholder_name}</td>
                            <td className="text-right">{val?.no_of_apartments}</td>
                            <td className="text-right">{val?.no_of_carspaces}</td>
                            <td className="text-right">{val?.no_of_other_spaces}</td>
                            <td className="text-right">{val?.percentage_of_shares || "0 %"}</td>
                        </tr>)
                    }) : <tr><td colSpan={5}><Empty description={props.TranslateString('Empty')}/></td></tr>}
                </tbody>
                <tfoot>
                    {shareholderData.length > 0 && props?.total ?
                        <tr className='bg-light'>
                            <td className='text-capitalize fw-600'>{props.TranslateString('Total')}</td>
                            <td className="text-right fw-600">{totalShareholder?.no_of_apartments }</td>
                            <td className="text-right fw-600">{totalShareholder?.no_of_carspaces }</td>
                            <td className="text-right fw-600">{totalShareholder?.no_of_other_spaces }</td>
                            <td className="text-right fw-600">{totalShareholder?.percentage_of_shares || "0 %"}</td>
                        </tr>
                        : ""} 
                </tfoot>
            </table>
        </>
    );
}

export default PDFPage8Table3;